/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var BroomIcon = createIcon({
  name: 'BroomIcon',
  height: 512,
  width: 512,
  svgPath: 'M10.8 247.2C-.7 251.8-3.7 266.7 5 275.4l54.8 54.8 73.2-24.4-24.4 73.2 128 128c8.8 8.8 23.6 5.7 28.2-5.8l98.1-243.7-108.4-108.4-243.7 98.1zM507.3 27.3L484.7 4.7c-6.2-6.3-16.4-6.3-22.6 0L359.8 106.9l-40.4-40.4c-4.2-4.3-11.4-3-13.9 2.5l-27.2 58.6 106.1 106.1 58.6-27.2c5.4-2.5 6.7-9.7 2.5-13.9l-40.4-40.4L507.3 49.9c6.3-6.2 6.3-16.3 0-22.6z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default BroomIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/broom-icon.js
// module id = 405
// module chunks = 0